import React, {Component} from 'react';

import './Public.css';
import {Redirect} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import queryString from "query-string";


class PublicContext extends Component {

  componentWillMount(){
    const {dealer, brand} = this.props.match.params;

    const {bookingToken} = queryString.parse(this.props.location.search);

    this.props.dispatchSetPublicContext({dealer, brand, bookingToken});
  }

  render() {
  const {publicContextLoading} = this.props
    if (publicContextLoading){
      return null;
    }
    return (
      <Redirect to={`/public/login`}/>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSetPublicContext: params => dispatch({ type: 'SAVE.PUBLIC_CONTEXT.REQUEST', params }),
});

const mapStateToProps = state => ({
  publicContext: state.publicContext,
  publicContextLoading: state.publicContext.loading,
});

export default
  connect(
    mapStateToProps,
    mapDispatchToProps)
  (PublicContext);




// WEBPACK FOOTER //
// ./src/PublicContext.js